import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'primeng/toast';

/**
 * Point d'affichage unique des messages applicatifs (succès, erreurs, info),
 * à instancier une seule fois dans le shell racine (`app.html`). Les
 * composants applicatifs déclenchent un toast via `ToastService.info(...)` /
 * `success(...)` / `warning(...)` / `error(...)`, sans avoir à connaître ce
 * composant ni l'API `MessageService` de PrimeNG.
 */
@Component({
  selector: 'app-global-toast',
  imports: [Toast],
  templateUrl: './global-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalToastComponent {}
